import { render, staticRenderFns } from "./SchoolSubjectList.vue?vue&type=template&id=862c4610&"
import script from "./SchoolSubjectList.vue?vue&type=script&lang=ts&"
export * from "./SchoolSubjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports